import ModalInfo from "../../../components/lib/modalInfo";
import { RiErrorWarningLine } from "react-icons/ri";
import { GrCircleQuestion } from "react-icons/gr";

const ProductRegisterFormStep1 = ({ formik }) => {

    const handleImageChange = (file) => {
        if (!file) return;

        formik.setFieldValue("imageFile", file);
        formik.setFieldValue("imagePreview", URL.createObjectURL(file));
        formik.setFieldTouched("imageFile", true);
    };

    return (
        <div className="space-y-6 max-w-5xl mx-auto">
            {/* IMAGEM */}
            <div>
                <p className="mb-2 font-medium">Imagem do Produto</p>

                <div className={`flex justify-center border-2 border-dashed rounded-md p-4 transition-colors
                    ${formik.errors.imageFile ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}>

                    {formik.values.imagePreview ? (
                        <div className="relative w-40 h-40">
                            <img
                                src={formik.values.imagePreview}
                                className="w-full h-full object-contain rounded shadow-sm"
                                alt="Preview"
                            />
                            <button
                                type="button"
                                onClick={() => {
                                    formik.setFieldValue("imageFile", null);
                                    formik.setFieldValue("imagePreview", null);
                                }}
                                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 shadow-md hover:bg-red-600"
                            >
                                ✕
                            </button>
                        </div>
                    ) : (
                        <label className="cursor-pointer text-gray-500 w-full h-32 flex items-center justify-center">
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => handleImageChange(e.target.files[0])}
                            />
                            <div className="text-center text-sm font-medium">
                                <p className="text-blue-600">Clique para selecionar</p>
                                <p className="text-xs">Tamanho máximo: 25MB</p>
                            </div>
                        </label>
                    )}
                </div>
                {formik.errors.imageFile && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.imageFile}</p>
                )}
            </div>

            <label>
                <div className="flex relative items-center justify-between">
                    <p> Nome do Produto:</p>
                    <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                </div>

                <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.name && formik.errors.name ? 'border-red-500' : ''}`}
                    name="name"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name} />

                {formik.touched.name && formik.errors.name && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.name}</p>)}
            </label>

            <div className="grid grid-cols-2 gap-x-4 my-4">
                <label>
                    Código de Barras:
                    <input
                        className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.barcode && formik.errors.barcode ? 'border-red-500' : ''}`}
                        name="barcode"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.barcode} />

                    {formik.touched.barcode && formik.errors.barcode && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.barcode}</p>)}
                </label>

                <label>
                    Marca:
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.brand && formik.errors.brand ? 'border-red-500' : ''}`}
                        name="brand"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.brand} />

                    {formik.touched.brand && formik.errors.brand && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.brand}</p>)}
                </label>
            </div>

            <div className="grid lg:grid-cols-2 gap-x-4 my-4">
                <label>
                    <div className="flex items-center justify-between">
                        <p>Quantidade em Estoque:</p>
                        <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                    </div>
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.quantity && formik.errors.quantity ? 'border-red-500' : ''}`}
                        name="quantity"
                        type="number"
                        min="0.00"
                        step='1'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.quantity} />

                    {formik.touched.quantity && formik.errors.quantity && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.quantity}</p>)}
                </label>
            </div>

            <div className="grid lg:grid-cols-2 gap-x-4 my-4">          
                <label>
                    <div className="flex items-center justify-between">
                        <p>Preço:</p>
                        <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                    </div>
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.price && formik.errors.price ? 'border-red-500' : ''}`}
                        name="price"
                        type="number"
                        step="0.01"
                        min="0.00"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.price} />

                    {formik.touched.price && formik.errors.price && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.price}</p>)}
                </label>
                 <label>
                    <div className="flex items-center justify-between">
                        <p>Preço Online (R$):</p>
                        <ModalInfo icon={<GrCircleQuestion />} content="Opcional. Se diferente do preço padrão, usado nas compras online pelo responsável." />
                    </div>
                    <input className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        name="online_price"
                        type="number"
                        step="0.01"
                        min="0.00"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.online_price} />
                </label>
            </div>

            <div className="grid lg:grid-cols-2 gap-x-4 my-4">
                <label> Data de Fabricação:
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.fabrication_date && formik.errors.fabrication_date ? 'border-red-500' : ''}`}
                        name="fabrication_date"
                        type="date"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.fabrication_date} />

                    {formik.touched.price && formik.errors.price && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.fabrication_date}</p>)}
                </label>

                <label> Data de Validade:
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.expiration_date && formik.errors.expiration_date ? 'border-red-500' : ''}`}
                        name="expiration_date"
                        type="date"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.expiration_date} />

                    {formik.touched.expiration_date && formik.errors.expiration_date && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.expiration_date}</p>)}
                </label>
            </div>
        </div>
    );
};

export default ProductRegisterFormStep1;
